// lib
import React from 'react'
import PropTypes from 'prop-types'
import { Repeat } from 'immutable'

// styles
import style from '@aytm/lib/rfd-ui/styles/basic/loader-dots.module.scss'

// <Component>
LoaderDots.propTypes = {
  dots: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dotSize: PropTypes.number
}
export default React.memo(
  LoaderDots,
  (prevProps, nextProps) =>
    prevProps.dots === nextProps.dots &&
    prevProps.height === nextProps.height &&
    prevProps.dotSize === nextProps.dotSize
)
function LoaderDots(props) {
  const { dots = 3, dotSize, height } = props
  const lineHeight = 'number' == typeof height ? `${height}px` : height
  return (
    <div className={style.component} style={{ lineHeight }}>
      {Repeat(null, dots)
        .map((_v, i) => (
          <span
            key={i}
            className={`${style.dot} ${style[`dot-${i % 3}`]}`}
            style={{
              width: dotSize,
              height: dotSize,
              lineHeight,
              marginRight: dotSize && i < dots - 1 ? dotSize / 2 : null,
              borderRadius: dotSize ? dotSize / 2 : null
            }}
          />
        ))
        .toArray()}
    </div>
  )
}
